import { render, staticRenderFns } from "./ReporteAsignacion.vue?vue&type=template&id=a7b124b2"
import script from "./ReporteAsignacion.vue?vue&type=script&lang=js"
export * from "./ReporteAsignacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports